module.exports = __webpack_public_path__ + "img/auweblogo-en.d2ac7604.d2ac7604.png";